<template>
  <div style="margin-top:0px;margin-bottom:300px;">
    <div class="info-bar">
      <h3 class="module-title">
        Relatórios
        <i class="icon icon-alert-circle-i"></i>
        <div class="module-description-tooltip">asfasf</div>
      </h3>
      <div>
        <div class="control-group">
          <label class="control-label" for="issuanceDate">Data de início</label>
          <div class="controls">
            <date-input class="form-control"></date-input>
          </div>
        </div>
      </div>

      <div>
        <div class="control-group">
          <label class="control-label" for="issuanceDate">Data final</label>
          <div class="controls">
            <date-input class="form-control"></date-input>
          </div>
        </div>
      </div>

      <div>
        <div class="control-group">
          <label class="control-label" for="issuanceDate"></label>
          <div class="controls">
           <lms-button style="margin-right:5px;" :loading="false">Filtrar</lms-button>
          </div>
        </div>
      </div>

     
    </div>

    <div class="row">
      <div class="col-lg-6">
        <large-bar-chart
          v-if="dailyChartData"
          :title="'Vendas diárias'"
          :typeDate="'day'"
          :chartData="dailyChartData[0].data"
        />
      </div>
      <div class="col-lg-6">
        <large-bar-chart :title="'Vendas mensais'" :typeDate="'month'" :chartData="monthSalesData" />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <large-bar-chart
          v-if="dailyChartData"
          :title="'Taxa de conversão'"
          :typeDate="'day'"
          :chartData="dailyChartData[0].data"
        />
      </div>
    </div>

    <div class="row box-outer">
      <div class="box-inner" v-if="productsSalesData">
        <div v-for="(p,index) in productsSalesData" :key="index" class="thumb">
          <product :productName="p.name" :chartData="p.data" />
        </div>
      </div>
      <loading v-else :color="'#1abdde'" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Product from "./Widgets/Product";
import LargeBarChart from "./Widgets/LargeBarChart";
import { mapState } from "vuex";

export default {
  props: {
    loadingData: {
      type: Boolean,
      required: false
    },
    chartData: {
      type: Array,
      required: false
    },
    dailyChartData: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      selectedStudent: 0,
      selectedCourse: 0
    };
  },
  computed: mapState(["productsSalesData", "monthSalesData","paymentRateData"]),
  components: {
    LargeBarChart,
    Product
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/partials/variables";

::-webkit-scrollbar {
  width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $secondary-color;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $base-color;
}
.box-outer {
  width: 100%;
  position: relative;
}
.box-inner {
  width: 100%;
  position: absolute;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
}
.thumb {
  width: 30%;
  margin: 10px;
  display: inline-block;
}
</style>
